import React from "react";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface ResolveDeficiencyButtonProps {
  isActionAvailable: boolean;
  onResolve?: () => void;
}

const ResolveDeficiencyButton: React.FC<ResolveDeficiencyButtonProps> = ({
  isActionAvailable,
  onResolve = () => {},
}) => {
  return (
    <FlowActionButton
      langBase="deficiencies.actions"
      isActionAvailable={isActionAvailable}
      labelKey="resolve"
      testId="resolve"
      variant="outlined"
      startIcon={<ContentPasteGoIcon />}
      onClick={onResolve}
    />
  );
};

export default ResolveDeficiencyButton;
